import './css/grid.css';
import './css/magnific-popup.css';
import './css/font-awesome.min.css';
import './css/flaticon.css';
import './css/style.css';
import './css/style-my.css';
import './js/device.min';
import './js/jquery.parallax.min';
import './js/jquery.magnific-popup.min';

import angular from '../node_modules/angular';

//import route from './config/route';
//import './pages';
import './controllers/Main.js';

const app = angular.module('app', []);


app.directive ('parallax', [ function() {

  return {
    restrict: 'E',
    templateUrl: 'pages/Parallax/parallax.html',
    controllerAs: 'ParallaxCtrl',

    link: function ($scope, element, attribute) {
      this.$scope = $scope;

      /* Hero height for full and half screen
       ==================================================================================== */
      var windowHeight = $(window).height();
      $('.hero').height(windowHeight - 80);
      $('.hero.mvisible').height(windowHeight - 136);

      $(window).resize(function() {
        var windowHeight = $(window).height();
        $('.hero').height(windowHeight - 80);
        $('.hero.mvisible').height(windowHeight - 136);
      });

      /* Responsive Menu - Expand / Collapse on Mobile
       ==================================================================================== */
      function recalculate_height() {
        var nav_height = $(window).outerHeight();
        $("#navigation").height(nav_height - 56);
      }

      $('#menu-toggle-wrapper').on('click', function(event) {
        recalculate_height();
        $(this).toggleClass('open');
        $("body").toggleClass('open');
        $('#navigation').slideToggle(200);
        event.preventDefault();
      });

      $(window).resize(function() {
        recalculate_height();
      });

    }
  };
}]);

app.directive ('fotky', [ '$http', function( $http ) {

  return {
    restrict: 'E',
    templateUrl: 'pages/Fotky/fotky.html',
    controllerAs: 'FotkyCtrl',

    link: function($scope, element, attribute) {

      this.$scope = $scope;

      $scope.album = 'spolocne';

      $scope.fotos = [];

      $scope.isSet = function( album ) {
        return $scope.album === album;
      }

      $scope.setAlbum = function( album ) {
        $scope.album = album;
        $scope.getNewAlbum( album );
      }

      $scope.getNewAlbum = function( album ) {

        if(!album) {
          album = this.album;
        }

        $http.get('json/fotky-'+album+'.json')
          .then(function(res){
            $scope.fotos = res.data;
          })
          .catch(function(response) {
            console.error('chyba', response.status, response.data);
          })
        ;
      }

      this.getGallery( element );
      this.setDefaultAlbum();
    },

    setDefaultAlbum() {
      this.$scope.getNewAlbum( this.$scope.album );
    },

    getGallery( element ) {

      var elem = angular.element(document.querySelector('#wedding-gallery'))
      angular.element(elem).magnificPopup({
        delegate: '.block:not(.isotope-hidden) a',
        type: 'image',
        tLoading: 'Nahrávam fotku #%curr%...',
        mainClass: 'mfp-img-mobile',
        closeOnBgClick: false,
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        },
        zoom: {
          enabled: true,
          duration: 300, // don't foget to change the duration also in CSS
          opener: function(element) {
            return element.parent().find('img');
          }
        },
        image: {
          cursor: null,
          markup: '<div class="mfp-figure">' +
          '<div class="mfp-close"></div>' +
          '<div class="mfp-img"></div>' +
          '<div class="mfp-bottom-bar">' +
          '<div class="mfp-title"></div>' +
          '<div class="mfp-counter"></div>' +
          '</div>' +
          '</div>' +
          '<div class="small-gallery-wrapper"><div class="small-gallery"></div></div>',
          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
          titleSrc: function(item) {
            return item.el.find('.portfolio-title').text(); // place .html() if you need to show categories too.
          }
        },
        setActive: function($gallery, ind) {

          if (ind !== false) {
            $gallery.find('img').removeClass('active');
            $gallery.find('img:eq(' + ind + ')').addClass('active');
          }

          var active_left = $gallery.find('img.active').position().left;
          var gall_width = $gallery.parent().width() / 2;
          var active_width = $gallery.find('img.active').width() / 2;

          $gallery.css('left', -((active_left - gall_width) + active_width));

        },
        callbacks: {
          open: function() {
            var $gallery = this.contentContainer.find('.small-gallery');
            var magnificPopup = this;
            $.each(this.st.items, function(i) {
              var $img = $(this).parent().find('img');
              $gallery.append($("<img />", {
                src: $img.attr('src')
              }).on('click', function() {
                magnificPopup.goTo(i);
              }));
            });

            this.content.find('img.mfp-img').load(function() {
              magnificPopup.st.setActive($gallery, magnificPopup.currItem.index);
            });

          },
          change: function() {
            var img = this.content.find('img.mfp-img');
            var magnificPopup = this;
            var $gallery = this.contentContainer.find('.small-gallery');

            // Smanjujemo velicinu slika
            img.css('max-height', parseFloat(img.css('max-height')) * 0.85);

            if ($gallery.find('img').length) {
              img.load(function() {
                magnificPopup.st.setActive($gallery, magnificPopup.currItem.index);
              });
            }

          },
          resize: function() {

            var img = this.content.parent().find('img.mfp-img');
            var $gallery = this.contentContainer.find('.small-gallery');

            img.css('max-height', parseFloat(img.css('max-height')) * 0.85);

            if ($gallery.find('img').length) {
              this.st.setActive(this.contentContainer.find('.small-gallery'), false);
            }
          }
        }
      });
    }

  };
}]);

app.directive ('podakovanie', [ function() {

  return {
    restrict: 'E',
    templateUrl: 'pages/Podakovanie/podakovanie.html',
    link: function ($scope, element, attribute) {
      this.$scope = $scope;
    }
  };
}]);


app.directive ('copyright', [ function() {

  return {
    restrict: 'E',
    templateUrl: 'pages/Copyright/copyright.html',
    link: function ($scope, element, attribute) {
      this.$scope = $scope;
    }
  };
}]);

app.directive ('logo', [ function() {

  return {
    restrict: 'E',
    templateUrl: 'pages/Logo/logo.html',
    link: function ($scope, element, attribute) {
      this.$scope = $scope;
    }
  };
}]);






/** WEBPACK FOOTER **
 ** ./app/app.js
 **/